import type { VV } from '@semios/app-platform-value-type-definitions'
import moment from 'moment-timezone'
import { unitConverter } from 'utils/unitConverter/unitConverter'
import type { TSplineSeriesData } from '../../types'

export const processPressureData = (
  pressureDataMap: Record<
    string,
    NonNullable<NonNullable<VV.Response['points']>[string]['values']['irrigationPressureSemios_pump']>
  >,
  pointLngLat: string,
  showPressure: boolean,
  timezone: string,
): TSplineSeriesData[] => {
  if (!showPressure) return []

  return (pressureDataMap[pointLngLat] ?? []).flatMap((p) =>
    p?.timeseries
      ? (p.timeseries ?? []).map((d) => {
          const value = unitConverter.irrigationPressure(d.value === null ? null : d.value.average).value()

          return {
            x: moment.tz(d.timestamp, timezone).valueOf(),
            y: value === null ? undefined : value,
          }
        })
      : [],
  )
}
